export default "__VITE_ASSET__CrYVimkh__"